import moment, { type MomentInput } from 'moment';
import { DATE_FORMAT } from 'src/constants';

export default function getDateMoment(s: MomentInput, format = DATE_FORMAT) {
  const dateMoment = s ? moment(s, format) : null;
  return dateMoment?.isValid() ? dateMoment : null;
}
